import Image from 'next/image'
import React from 'react'
import { BaseCard } from '../BaseCard'
import { DiscountHeader } from '../DiscountHeader'
// import { toBase64, shimmer } from 'src/common/utils'
import { Overlay } from '../Overlay'

type FeaturedMerchCardProps = {
    imageURL: string
    title: string
    price: string
    isFavorited: boolean
    percentOff: number
    href: string
}

export const FeaturedMerchCard = ({
    imageURL,
    title,
    price,
    // isFavorited = false,
    percentOff = 0,
    href
}: FeaturedMerchCardProps) => {
    return (
        <BaseCard href={href} cardType="narrow" boxShadow={false}>
            <Image
                alt={`${title} card image`}
                src={imageURL}
                key={`featured-merch-${imageURL}`}
                width={225}
                height={300}
                objectFit="cover"
                className="bg-gray-400"
                // placeholder="blur"
                // blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(225, 300))}`}
            />
            <DiscountHeader percent={percentOff} />
            <div className="flex flex-col pt-10 px-2 items-center text-center z-10 absolute bottom-4 left-0">
                <p className="-mt-0 mb-1.5 text-white text-xl font-normal line-clamp-2">
                    {title}
                </p>
                <p className="-mb-0 text-lg text-yf-green font-normal">{price}</p>
            </div>
            <Overlay />
        </BaseCard>
    )
}
